// extracted by mini-css-extract-plugin
export var arrow = "Arrow-module--arrow--jwV7c";
export var arrowPrimary = "Arrow-module--arrow--primary--2xmWI";
export var arrowDark = "Arrow-module--arrow--dark--lf_hC";
export var arrowLeft = "Arrow-module--arrow--left--2P80U";
export var arrowRight = "Arrow-module--arrow--right--1Ql-l";